import { useContext } from "react";
import { ArrowUpRight, Building2, CheckCircle2, CircleAlert, RefreshCw, UsersRound } from "lucide-react";

import { AuthContext } from "src/context/AuthContext";
import StagePage from "src/stage/StagePage";
import { characterFor } from "src/stage/characters";
import { firstName } from "src/stage/StageUi";
import { useWorkspace } from "../context/WorkspaceContext";
import "src/features/Stage/home.css";

const appy = characterFor("appy");

// AUTO-CRM-32: first run, before the account belongs to any CRM workspace.
export default function WorkspaceOnboarding() {
  const { currentUser, refreshSession } = useContext(AuthContext);
  const { error, fetchWorkspaces, openCreateModal } = useWorkspace();

  const refreshWorkspaceAccess = async () => {
    const workspaces = await fetchWorkspaces();
    if (workspaces.length > 0) await refreshSession();
  };

  return (
    <StagePage>
      <section className="ws-spot crm-onboard ws-rise">
        <div className="ws-spot-art crm-home-spot-halo" aria-hidden="true" />
        {appy?.full && <img className="ws-spot-art crm-onboard-art" src={appy.full} alt="" aria-hidden="true" />}
        <span className="ws-eyebrow">Welcome to Auto Appy CRM</span>
        <h1 className="crm-onboard-title">{firstName(currentUser?.name) ? `${firstName(currentUser.name)}, let’s connect your CRM to a workspace.` : "Let’s connect your CRM to a workspace."}</h1>
        <p className="ws-muted crm-onboard-copy">A workspace keeps your team, leads, pipelines and permissions together, and it’s the same organisation you use across Auto Appy.</p>
      </section>

      {error && <div className="ws-notice" role="alert"><CircleAlert size={16} style={{ flex: "none", marginTop: 1 }} />{error}</div>}

      <div className="crm-onboard-grid">
        <section className="ws-card ws-card-pad crm-onboard-card ws-rise">
          <span className="crm-onboard-icon is-primary" aria-hidden="true"><Building2 size={20} /></span>
          <h2 className="ws-h2">Create my workspace</h2>
          <p className="ws-muted">Choose this if you own or run the company CRM. You become the admin and can invite teammates afterwards.</p>
          <ul className="crm-onboard-list">
            <li><CheckCircle2 size={15} />Set up company details</li>
            <li><CheckCircle2 size={15} />Manage team roles and access</li>
          </ul>
          <button type="button" onClick={openCreateModal} className="ws-btn ws-btn--primary">Set up in Auto Appy<ArrowUpRight size={14} /></button>
        </section>

        <section className="ws-card ws-card-pad crm-onboard-card ws-rise">
          <span className="crm-onboard-icon" aria-hidden="true"><UsersRound size={20} /></span>
          <h2 className="ws-h2">Join my company’s workspace</h2>
          <p className="ws-muted">If your company already uses Auto Appy CRM, ask an admin to add <strong>{currentUser?.email || "the email on your Auto Appy account"}</strong>.</p>
          <div className="crm-onboard-note">Once they’ve added you, refresh your access here. Your role decides what you can see and change.</div>
          <button type="button" onClick={refreshWorkspaceAccess} className="ws-btn ws-btn--quiet"><RefreshCw size={14} />Refresh workspace access</button>
        </section>
      </div>
    </StagePage>
  );
}
